import { css } from '@emotion/react';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import { spacing, colors } from '@ownhealthil/wound-ui';

const rootCss = css`
  margin: ${spacing.space6} 0;
  padding: ${spacing.space6} 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.secondary};
`;

function Loader() {
  return (
    <Paper css={rootCss}>
      <CircularProgress color="inherit" size={24} thickness={4} />
    </Paper>
  );
}

export default Loader;
